import React from 'react';
import { motion } from 'framer-motion';

const benefits = [
    { k: '15-25', l: 'reuniones B2B calificadas pre-agendadas' },
    { k: '3-5', l: 'oportunidades comerciales concretas' },
    { k: '100%', l: 'agenda personalizada según tu objetivo' },
    { k: '90 días', l: 'de seguimiento post-feria estructurado' },
    { k: '+40', l: 'contactos calificados en tu CRM' },
    { k: '1', l: 'roadmap de escala listo para ejecutar' },
];

const Benefits = () => (
    <section id="beneficios" className="relative py-16 md:py-20 border-t border-white/10 overflow-hidden">
        {/* subtle warm glow */}
        <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[500px] w-[500px] rounded-full" style={{ background: 'radial-gradient(closest-side, rgba(245,158,11,0.12), transparent 70%)' }} />

        <div className="relative mx-auto max-w-[1440px] px-6 md:px-10">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.7 }}
                className="mb-10 max-w-4xl"
            >
                <div className="eyebrow-brand mb-6">Con qué vuelves a casa</div>
                <h2 className="font-display text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
                    Resultados <span className="italic-accent text-[color:var(--brand)] font-normal">medibles.</span> No promesas.
                </h2>
                <p className="mt-6 text-white/70 text-lg leading-relaxed max-w-[60ch]">
                    Cada empresa que viaja con la Tribu tiene indicadores claros y comparables.
                    Estos son los mínimos de una misión bien ejecutada.
                </p>
            </motion.div>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
                {benefits.map((b, i) => (
                    <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: '-60px' }}
                        transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                        className="bg-[color:var(--bg)] p-6 md:p-10 min-h-[180px] flex flex-col justify-between"
                    >
                        <div className="num-display text-[color:var(--brand)] text-3xl md:text-4xl leading-none">
                            {b.k}
                        </div>
                        <div className="text-sm md:text-base text-white/75 leading-snug mt-3 max-w-[26ch]">
                            {b.l}
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);

export default Benefits;
